import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { fmtINR, fmtDate } from "@/lib/format";

export default function SlowMovingStock() {
  const [days, setDays] = useState(60);
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/reports/slow-moving?days=${days}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [days]);
  if (!d) return <div className="text-sm text-muted-foreground p-4">Loading…</div>;
  return (
    <div className="space-y-4" data-testid="slow-moving-stock">
      <div className="flex items-end justify-between">
        <div className="text-[10px] font-mono uppercase text-muted-foreground">// Slow-moving stock · idle {'>'} {days}d</div>
        <div><Label className="text-[10px]">Threshold days</Label><Input type="number" value={days} onChange={(e) => setDays(Number(e.target.value))} className="rounded-sm h-8 w-24 tabular-nums" data-testid="sm-days" /></div>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        <Card className="rounded-sm p-3"><div className="text-[10px] font-mono uppercase text-muted-foreground">Items</div><div className="text-2xl font-bold tabular-nums mt-1">{(d.rows || []).length}</div></Card>
        <Card className="rounded-sm p-3"><div className="text-[10px] font-mono uppercase text-muted-foreground">Idle Qty</div><div className="text-2xl font-bold tabular-nums mt-1">{d.total_qty}</div></Card>
        <Card className="rounded-sm p-3 border-red-500/30 bg-red-500/10"><div className="text-[10px] font-mono uppercase text-red-800">Idle Value ₹</div><div className="text-2xl font-bold tabular-nums text-red-900 mt-1">{fmtINR(d.total_value)}</div></Card>
      </div>
      <div className="card-sharp overflow-hidden">
        <table className="w-full dense">
          <thead><tr><th>SKU</th><th>Item</th><th>Warehouse</th><th className="text-right">Qty</th><th>Last Outward</th><th className="text-right">Days Idle</th><th className="text-right">Value ₹</th></tr></thead>
          <tbody>
            {(d.rows || []).length === 0 && <tr><td colSpan="7" className="text-center py-10 text-muted-foreground">Nothing slow-moving.</td></tr>}
            {(d.rows || []).map((r, i) => (
              <tr key={i} data-testid={`sm-row-${r.sku}`}>
                <td className="font-mono text-xs">{r.sku}</td>
                <td>{r.name}</td>
                <td>{r.warehouse_name}</td>
                <td className="text-right tabular-nums">{r.qty}</td>
                <td className="text-xs">{r.last_outward_date === "never" ? <span className="text-red-600 font-mono">never</span> : fmtDate(r.last_outward_date)}</td>
                <td className={`text-right tabular-nums font-medium ${r.days_idle > 180 ? "text-red-700" : r.days_idle > 90 ? "text-amber-700" : "text-muted-foreground"}`}>{r.days_idle > 9000 ? "∞" : r.days_idle}</td>
                <td className="text-right tabular-nums">{fmtINR(r.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
